module.exports = __webpack_public_path__ + "img/share_play.d6451328.svg";